import * as React from 'react';

function SvgSpring0(props) {
  return (
    <svg
      width={46}
      height={315}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.555 25.444v4.377l-10.052 4.108 20.103 8.218-20.103 8.217 20.103 8.217-20.103 8.217 20.103 8.218-20.103 8.217 20.103 8.217-20.103 8.217 20.103 8.218-20.103 8.217 20.103 8.217-10.052 4.109v4.376M22.555 182.115v4.387l-10.052 4.119 20.103 8.237-20.103 8.237 20.103 8.238-20.103 8.237 20.103 8.237-20.103 8.237 20.103 8.237-20.103 8.238 20.103 8.237-20.103 8.237 20.103 8.237-10.052 4.119v4.387"
        stroke={props.springcolor}
        strokeWidth={5}
        strokeLinecap="square"
      />
      <path
        d="M34.087 0h-23v23h23V0zM34.087 292h-23v23h23v-23z"
        fill="#5BAD92"
      />
    </svg>
  );
}

export default SvgSpring0;
